<template>
    <div>
        <div class="row" v-if="loading && !workshops.length">
            <Loader style="width: 100%;" />
        </div>
        <div v-if="workshops.length === 0">
            No canceled workshop were found.
        </div>
        <div v-else>
            <div class="session" v-for="(workshop, index) in workshops" :key="workshop.id">
                <div class="row">
                    <div class="col-12 col-lg-8">
                        <h3>{{ workshop.topic }}</h3>
                        <h5 v-if="workshop.host">{{ workshop.host.name }}</h5>
                        <p>
                            <b>Requested At:</b> 
                            {{ workshop.requested_time | format('MM/DD/YYYY h:mmA') }}
                        </p>
                        <p>
                            <b>Starting At:</b> 
                            {{ workshop.start_time | format('MM/DD/YYYY h:mmA') }}
                        </p>
                        <span class="spot-number d-lg-none">
                            <span>User Limit: {{workshop.maxNumberOfAttendees}}</span>
                        </span>
                    </div>
                    <div class="col-12 d-none d-lg-block col-lg-4 text-right">
                        <ul class="pills">
                            <li>User Limit: {{ workshop.maxNumberOfAttendees }}</li>
                        </ul>
                    </div>
                </div>
                <div class="row" v-if="workshop.struggle_areas.length">
                    <ul class="pills">
                        <li v-for="area of workshop.struggle_areas" :key="area.id">
                            {{area.name}}
                        </li>
                    </ul>
                </div>
                    <div class="row mb-2" v-show="workshop.document_url">
                        <div class="col-12 col-lg-4">
                            <a :href="workshop.document_url" target="_blank">
                            <button type="button"  class="btn btn-secondary btn-block w-100 border">
                                <span>Documents            </span>
                                <font-awesome-icon
                                    :icon="['fas', 'file-alt']"
                                    title="View Document"
                                    class="icon alt fa-fw"
                                />
                            </button>
                            </a>
                        </div>
                    </div>
                    <div class="accordion" role="tablist">
                        <b-card no-body class="mb-1">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <button class="btn btn-secondary block w-100" v-b-toggle="'collapse-description-'+ index">
                                View Description
                            </button>
                            </b-card-header>
                            <b-collapse :id="'collapse-description-'+ index" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="description">
                                    <b-card-text>{{ workshop.description}}</b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                        <b-card no-body class="mb-1" v-if="workshop && workshop.attendees && workshop.attendees.length">
                            <b-card-header header-tag="header" class="p-1" role="tab">
                                <button class="btn btn-secondary block w-100" v-b-toggle="'collapse-attendees-'+ index">
                                View Attendees
                            </button>
                            </b-card-header>
                            <b-collapse :id="'collapse-attendees-'+ index" accordion="my-accordion" role="tabpanel">
                                <b-card-body class="description">
                                    <b-card-text>
                                        <table class="responsive-table">
                                            <thead>
                                                <tr>
                                                    <th>First Name</th>
                                                    <th>Last Name</th>
                                                    <th/>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="attendee in workshop.attendees" :key="attendee.userId">
                                                    <td>
                                                        {{ attendee.firstName }}
                                                    </td>
                                                    <td>
                                                        {{ attendee.lastName }}
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </b-card-text>
                                </b-card-body>
                            </b-collapse>
                        </b-card>
                    </div>
                </div>
            <div>
                <Loader v-if="loading" style="width: 100%" />
                <button class='btn' v-else-if="pageToken" @click="loadWorkshops">
                    Load Next
                </button>
                <div v-else>
                    <p>
                        <font-awesome-icon :icon="['fas', 'check-circle']" class="icon alt" />
                        All Results Loaded
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import WorkshopClient from '@/api/WorkshopClient';
import Loader from '@/components/Loader';
import WorkshopView from '../WorkshopView';

export default {
    name: 'WorkshopsCanceledList',
    components : {
        Loader,
    },
    props: {
        filters: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            workshopClient: new WorkshopClient(this.$http),
            workshops: [],
            pageToken: 'WorkshopsByStartTimeAscending',
            loading: false,
            excludedStatuses: ['approved', 'requested']
        }
    },
    async mounted() {
        this.loadWorkshops();
    },
    methods: {
        async loadWorkshops() {
            
            try {
                this.loading = true;
                if (this.pageToken == null || this.pageToken == 'WorkshopsByStartTimeAscending') {
                    this.workshops.length = 0;
                }

                const response = await this.workshopClient.listForAdmin(
                    this.pageToken,
                    this.filters.counselor_id,
                    this.filters.start_time_after,
                    this.filters.start_time_before,
                    this.filters.related_topics,
                    this.excludedStatuses);
            
                this.pageToken = response.nextPageToken;

                for(const workshop of (response.workshops || []).map(this.toCounselorGroupSessionModel)){
                    this.workshops.push(workshop);
                }    
                
            } catch (ex) {
                console.error(ex)
            } finally {
                this.loading = false;
            }
        },
        toCounselorGroupSessionModel(val, index, arr){
            return new WorkshopView(val);
        },
        freshLoadWorkshops(){
            this.pageToken = 'WorkshopsByStartTimeAscending';
            return this.loadWorkshops();
        }
    }
}
</script>

<style lang="scss" scoped>
    .session {
      @include border-radius($border-radius);

      border: solid 1px rgba(white, 0.5);
      padding: 30px;
      margin-bottom: 10px;
      background-color: $off-blue;

      p {
        color: rgba(white, 0.75);
        font-size: 18px;
        margin-bottom: 20px;
      }

      .spot-number {
        color: $green;
        margin-bottom: 30px;
        display: block;
        font-weight: bold;
      }
    }

    .description {
        background-color: $textbox-bg-color;
        min-height: 100px;
        overflow: auto;
        word-wrap: break-word;

    }
    .accordion {
        .card {
            background-color: $off-blue;
            border: 0px;
        }
        .btn {
            background-color: $dark-green;
            border-color: $border-color;
        }
     
        .responsive-table {
            width:100%;
            th{
                border-bottom: 1px solid rgba(255, 255, 255, 0.25);
            }
            tbody {
                tr {
                    td {
                        padding: 0.75rem;
                        color: rgba(white, 0.87);
                        border-top: 1px solid rgba(255, 255, 255, 0.25);

                    a {
                        color: darken($highlight-color, 5%);
                    }
                }
            }
        }
        @media (max-width: $sm-max) {
      display: block;
      border: none;

      thead,
      tbody,
      th,
      td,
      tr {
        display: block;
      }

      tbody {
        tr {
          background: $dark-blue;
          border: solid 1px $border-color;

          td {
            padding: 0.75rem;
            text-align: right;
            border-bottom: none;
            border-top: 1px solid rgba(255, 255, 255, 0.25);

            &:first-of-type {
              border-top: none;
            }

            &:last-of-type {
              border-bottom: none;
            }
          }
        }
      }

      thead tr {
        position: absolute;
        top: -9999px;
        left: -9999px;
      }

      tr {
        @include border-radius($border-radius);

        margin: 0 0 1rem 0;
        background: white;
      }

      td {
        position: relative;
        padding-left: 50%;
        border: none;
        border-bottom: $secondary-border;

        label {
          position: absolute;
          top: 12.5px;
          left: 15px;
          width: 45%;
          padding-right: 10px;
          font-weight: bold;
          white-space: nowrap;
          text-align: left;
        }
      }

      .btn-ghost {
        border-color: $primary-color;
        background: $primary-color;
        color: $btn-color;
        height: 45px;

        &:hover,
        &:focus {
          border-color: darken($primary-color, 5%);
          background-color: darken($primary-color, 5%);
          color: $btn-color;
        }
      }
    }
        }
        
    }

</style>